// extracted by mini-css-extract-plugin
export default {"card":"spaces_card__OzihN","container":"spaces_container__52k2T","leftSide":"spaces_leftSide__J3n2A","rightSide":"spaces_rightSide__OCFLh"};